import {Avatar} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import Timestamp from '../Timestamp'
import {BiSolidLike} from "react-icons/bi";
import {renderIf, renderIfElse} from "../../../views/Shared";
import getTitle from "../../../helpers/getTitle";
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {LayoutContext} from "../../layouts/Default/LayoutContext";
import {GoDotFill} from "react-icons/go";
import {BsPersonFill} from "react-icons/bs";
import {BestCommentSvg} from "../../Svgs/BestCommentSvg";

export const BestComment = ({ item }) => {
  const t = useTranslate()
  const {isSm} = useContext(LayoutContext)

  if (_.isEmpty(item)) return null
  const creator = _.get(item, 'creator', {})
  const mentions = _.get(item, 'mentions', [])
  const comment = _.omit(item, ['creator'])

  return (
    <div className="flex flex-col gap-1 relative">
      <div className="flex items-center gap-2">
        <BestCommentSvg size={28}/>
        <span className="font-bold text-primary-700 uppercase tracking-wider">
          {t('best answer')}
        </span>
      </div>
      <div className="flex flex-col render-border-center-color text-green-600 rounded-r-lg relative py-2">
        <div
            style={{
              padding: '0.3rem',
              background: 'linear-gradient(to right, #e6ffeb 30%, rgba(0, 0, 0, 0) 70%)',
            }}
            className="flex items-center gap-2 rounded-l-lg">
          <Avatar
              size={30}
              src={creator.avatar}
              icon={<BsPersonFill size={16} className="text-color-500"/>}
              className="flex flex-center background-200"
          />
          <div className="flex flex-col">
            <Link
                to={getLinkToDetail(creator)}
                className="font-bold text-sm text-green-800 tracking-wide leading-tight no-underline">
              {renderIf(
                  creator?.patron_saint_name,
                  <span className="font-medium text-xs text-green-700 italic">
                    {creator?.patron_saint_name}{` `}
                  </span>
              )}
              {creator.name}
            </Link>
            <Timestamp
                className="w-fit font-medium text-green-500 text-2xs italic tracking-wide cursor-pointer"
                timestamp={item.created}
            />
          </div>
        </div>
        <div className="ml-3 my-2 overflow-x-hidden whitespace-pre-line">
          {renderIfElse(
              mentions?.length > 0,
              mentions.map((e, i) => {
                const owner = _.get(e, 'owner')
                return (
                    <span key={i} className="text-color-100">
                      {owner.content} {' - '}
                      <Link to={getLinkToDetail(owner.codi_document)} className="font-medium text-primary">
                        {getTitle(owner.codi_document)}
                      </Link>
                    </span>
                )
              }),
              <span className="text-color-100">
                {item.message}
              </span>
          )}
        </div>
        <div className="flex items-center gap-3">
          <GoDotFill size={10} className="text-color-400" />
          <div className="flex items-baseline gap-2 flex-1 italic leading-tight">
            <span className="text-xs text-color-500">
              {`${t('total vote')} : `}
            </span>
            <span className="font-bold text-sm text-green-700 leading-tight">
              {(item.total_votes).toLocaleString()}
            </span>
            <span className="font-medium text-xs text-green-700 lowercase">
              {t('votes')}
            </span>
          </div>
        </div>
        <div className="absolute top-5 right-5 z-3">
          <BiSolidLike size={ isSm ? 24 : 34 } className="jump-rotateY text-green-300" />
        </div>
      </div>
    </div>
  )
}

export const AskContentLayout = ({ style, children }) => {
  return (
    <div
      style={style}
      className="space-y-3">
      {children}
    </div>
  )
}

export default AskContentLayout
